import request from '@/utils/request'

let PushstreamApi = {

  /*笔记推流列表*/
  list(data) {
    return request._post('/shop/plus.pushstream.Index/index', data);
},
/*添加笔记推流*/
add(data) {
    return request._post('/shop/plus.pushstream.Index/add', data);
},
/*修改笔记推流*/
edit(data) {
    return request._post('/shop/plus.pushstream.Index/edit', data);
},
/*删除笔记推流*/
del(data) {
    return request._post('/shop/plus.pushstream.Index/del', data);
},
/*笔记推流详情*/
detail(data) {
  return request._post('/shop/plus.pushstream.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.pushstream.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.pushstream.Setting/getSetting', data, errorback);
    },
}
export default PushstreamApi;



// WEBPACK FOOTER //
// ./src/api/pushStream.js